import { render, staticRenderFns } from "./sliderShowDetail.vue?vue&type=template&id=be8201a8&"
import script from "./sliderShowDetail.vue?vue&type=script&lang=js&"
export * from "./sliderShowDetail.vue?vue&type=script&lang=js&"
import style0 from "./sliderShowDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports